module.exports = __webpack_public_path__ + "img/customer01.004ea823.png";